import { render } from "./SidebarWidget.vue?vue&type=template&id=556ec064&ts=true"
import script from "./SidebarWidget.vue?vue&type=script&lang=ts"
export * from "./SidebarWidget.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__